import { fromPairs, map } from 'lodash/fp';
import React, { ReactNode } from 'react';
import { pipe } from 'ts-opt';
import { AssociationRoleManagement } from 'api/gen/AssociationRoleManagement';
import { UserProfileSubjectRoleManagementDtoAssociationRoleManagement } from 'api/gen/UserProfileSubjectRoleManagementDtoAssociationRoleManagement';
import { DynamicContent } from './gen-dynamic-content';
import { ManagementAssociationsTableType } from '../../types/management-associations';
import { getExpirationColor } from '../../utils/get-expiration-color';
const genDynamicColumns = (roles: Array<AssociationRoleManagement>, onCellClick: (userProfileAssociationRoleId: number) => void): Record<string, ReactNode> => pipe(roles, map(role => [role.roleId.toString(), <span key={role.roleId} className={getExpirationColor(role.bindingExpiration)}>
            <DynamicContent key={role.roleId} onCellClick={onCellClick} userProfileAssociationRoleId={role.userProfileAssociationRoleId} />
        </span>]), fromPairs);

/**
 * Maps association-management API rows into the tree-table representation.
 *
 * @param row Source API row with association access data and role bindings.
 * @param onCellClick Callback invoked when a role cell is activated.
 * @returns The association-management table row.
 *
 * @example
 * managementAssociationsRowMapper(row, handleRoleClick);
 */
export const managementAssociationsRowMapper = (row: UserProfileSubjectRoleManagementDtoAssociationRoleManagement, onCellClick: (userProfileAssociationRoleId: number) => void): ManagementAssociationsTableType => ({
  id: row.userProfileId,
  username: row.username,
  userProfileId: row.userProfileId,
  roles: row.roles,
  isSubjectMember: row.isSubjectMember,
  ...genDynamicColumns(row.roles, onCellClick)
});